import { lazy } from 'react';

const Chat = lazy(
  () =>
    import(
      /* webpackChunkName: "Chat" */ 'src/mobile/pages/Conversation/index'
    ),
);

const ChatRecord = lazy(
  () =>
    import(
      /* webpackChunkName: "ChatRecord" */ 'src/mobile/pages/Conversation/subPages/ChatRecord/index'
    ),
);

const UserInfo = lazy(
  () =>
    import(
      /* webpackChunkName: "UserInfo" */ 'src/mobile/pages/Conversation/subPages/UserInfo/index'
    ),
);

const chatRoutes = [
  {
    name: '对话',
    path: '/mobile/chat',
    Component: Chat,
  },
  {
    name: '对话记录',
    path: '/mobile/chat-record',
    Component: ChatRecord,
  },
  {
    name: '个人中心',
    path: '/mobile/userinfo',
    Component: UserInfo,
  },
];

export default chatRoutes;
